<dynamic-form
[apiName]="apiName"
[label]="label"
[group]="formGroup"
[model]="model"
[areaName]="areaName"
[columns]="columns"
(cancelChange)="cancel()"
(submitChange)=" submitValue()">
</dynamic-form>